<template>
	<div class="uploadClass">
		<el-badge :hidden="getNum==0" :value="getNum" class="item" type="primary">
			<el-button type="primary" size="small" @click="uploadDialogVisible = true">
				附件<i class="el-icon-upload"></i>
			</el-button>
		</el-badge>
		<el-dialog title="文件上传管理器" :visible.sync="uploadDialogVisible" width="500px" center append-to-body>
			<el-upload class="upload-demo" :show-file-list="false" ref="upload" :on-change="handleChange" action="http://localhost:8080" :before-upload="beforeUpload" :on-preview="handlePreview" :on-remove="handleRemove" :file-list="fileList" :auto-upload="true">
				<el-button slot="trigger" size="small" type="success">选取文件</el-button>
				<!--<el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">上传到服务器</el-button>-->
				<!--<div slot="tip" class="el-upload__tip"></div>-->
			</el-upload>
			<el-table :data="fileList" style="width: 100%" height="260px">
				<el-table-column :show-overflow-tooltip="true" label="文件名" width="110">
					<template slot-scope="scope">
						<span style="margin-left: 10px">{{ scope.row.name }}</span>
					</template>
				</el-table-column>
				<el-table-column label="文件大小" width="110">
					<template slot-scope="scope">
						<i class="el-icon-document"></i>
						<span style="margin-left: 2px">{{formatToMb(scope.row.size )}}</span>
					</template>
				</el-table-column>
				<el-table-column label="状态" width="110">
					<template slot-scope="scope">
						<el-tag size="medium">{{ scope.row.status }}</el-tag>
					</template>
				</el-table-column>
				<el-table-column label="操作">
					<template slot-scope="scope">
						<!--<el-button type="success" icon="el-icon-search" circle></el-button>-->
						<el-button type="danger" icon="el-icon-close" circle @click="handleDelete(scope.$index, scope.row)"></el-button>
					</template>
				</el-table-column>
			</el-table>
			<div style="height: 100px;width: 100%;background-color: beige;">
				<el-scrollbar style="height: 100%;">
					历史上传附件:
					<fileListView :fileList="historyList"></fileListView>
				</el-scrollbar>
			</div>
			<p style="color: red;">*上传文件过后请点击确定完成上传</p>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="sentFiles">确定</el-button>
   				<el-button type="primary" @click="uploadDialogVisible = false">关闭</el-button>
			</span>
		</el-dialog>
	</div>
</template>
<script>
	import fileListView from "@/components/common/fileListView.vue";
	export default {
		name: 'uploadFiles',
		components: {
			fileListView
		},
		data() {
			return {
				filesNum: 0,
				historyList: [],
				fileList: [],
				uploadDialogVisible: false,
			};
		},
		props: {
			filesArray: {
				type: Array,
				default: function() {
					return []
				}
			},
		},
		mounted() {},
		watch: {
			'filesArray': {
				handler(val, oldVal) {
					this.historyList = val
				},
				deep: true
			},
		},
		created() {},
		methods: {
			sentFiles() {
				//this.$refs.upload.submit();
				var _this = this
				this.$emit("newList", this.fileList, function(str) {
					if(str == 'true') {
						_this.uploadDialogVisible = false
					} else {
						console.log("传递文件出错了")
						_this.uploadDialogVisible = false
					}
				});
			},
			reset() {
				this.filesNum = 0
				this.historyList = []
				this.fileList = []
			},
			handleDelete(index, row) {
				this.fileList.splice(index, 1)
			},
			formatToMb(size) {
				if(size / 1024 / 1024 < 5) {
					return parseInt(size / 1024) + 'kb'
				} else {
					return parseInt(size / 1024 / 1024) + 'mb'
				}
			},
			beforeUpload(file) {
				this.fileList.push(file)
				console.log('lllll', file)
			},
			submitUpload() {
				this.$refs.upload.submit();
			},
			handleRemove(file, fileList) {},
			handlePreview(file) {},
			handleChange(file, fileList) {
				//this.fileList = fileList
			}
		},
		computed: {
			getNum() {
				return this.fileList.length + this.historyList.length
			}
		}
	}
</script>

<style scoped>
	.uploadClass .el-table td,
	.uploadClass .el-table th.is-leaf {
		border-bottom: 1px solid #a4c3ff;
	}
</style>